// invoice-misc-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'r1i.send.cheerAlt': 'Plumma cheering',
  'r1i.send.postAlt': 'Postplumma with an envelope',
  'r1i.main.parcelAlt': 'SuperPlumma with a parcel',
  'r1i.preview.subscription': 'Subscription:',
  'r1i.preview.rental': 'Rental:',
});
